import { Box } from "@chakra-ui/react";
import LoginForm from "../components/LoginForm";

const LoginPage = () => {
  return (
    <div className="auth-page">
      <Box className="auth-content" textAlign="center">
        <LoginForm />
      </Box>
    </div>
  );
};

export default LoginPage;